import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Home, { AnimationContext } from './components/pages/Home';
import Legal from './components/pages/Legal';
import FAQ from './components/pages/FAQ';
import ReactGA from 'react-ga';

ReactGA.initialize('UA-62400457-3');
ReactGA.pageview(window.location.pathname + window.location.search);
class App extends Component {
  state = {
    playIntro: true,
    showStore: false,
  }

  setIntro = (playIntro) => {
    this.setState({playIntro});
  }

  setshowStore = (showStore) => {
    this.setState({ showStore});
  }

  render () {
    return (
      <AnimationContext.Provider value={{ 
        playIntro: this.state.playIntro,
        setIntro: this.setIntro,
        showStore: this.state.showStore,
        setshowStore: this.setshowStore,
      }}>
        <Router>
          <div className="bubbles" />
            <Switch>
              <Route exact path="/" component={Home} />
              <Route exact path="/legal" component={Legal} />
              <Route exact path="/legal/:id" component={Legal} />
              <Route exact path="/faq" component={FAQ} />
              <Route exact path="/faq/:id" component={FAQ} />
            </Switch>
        </Router>
      </AnimationContext.Provider>
    );
}
}

export default App;
